import type { SavedVocabularyItem } from '@/services/api/vocabulary.api';
import type { VocabItem } from '@/types/vocabulary.types';

/** Adapta una fila de `/users/me/vocabulary` al shape mostrado por VocabCard / VocabularyFlashcard. */
export function savedVocabularyToVocabItem(saved: SavedVocabularyItem): VocabItem {
  return {
    id: saved.id,
    word: saved.word,
    partOfSpeech: saved.partOfSpeech?.trim() || '—',
    ipa: '',
    translationEs: '',
    definitionEn: saved.definition ?? '',
    exampleSentence: saved.example?.trim() || '—',
    exampleTranslationEs: '',
    tags: [],
    relatedWords: [],
    wordAudioUrl: saved.wordAudioUrl ?? undefined,
  };
}
